const env = {
    NEO4J_SCHEME: process.env.REACT_APP_NEO4J_SCHEME,
    NEO4J_HOST: process.env.REACT_APP_NEO4J_HOST,
    NEO4J_PORT: process.env.REACT_APP_NEO4J_PORT,
    NEO4J_USER: process.env.REACT_APP_NEO4J_USER,
    NEO4J_PASSWORD: process.env.REACT_APP_NEO4J_PASSWORD,
};

export default env;